function track(event: string) {
  if (process.env.NODE_ENV === `production` && typeof fbq === `function`) {
    fbq('track', event);
  }
}

export default { track }